import React from 'react';
import CircularGallery from './CircularGallery';
import "./reviews.css";

const Details = () => {
    return (
        <div style={{  color: '#fff', paddingTop: '30px' }}>
            <div className="reviews-hero">
                <p className="reviews-title">Home of Tampa’s Best Subs</p>
                {/* <p className="reviews-sub">
                    We’re committed to quality in every detail. Our subs are made with premium
                    ingredients, fresh baked bread, and genuine care from start to finish.

                </p> */}
            </div>



            <div style={styles.container}>
                <div style={styles.galleryWrapper}>
                <CircularGallery 
                        bend={3}
                        textColor="#ffffff"
                        fontFamily='FontBold'
                        borderRadius={0.05}
                        scrollEase={0.03}
                    />
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: {
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '-80px',
        marginBottom: '-60px',
    },
    galleryWrapper: {
        width: '100%',
        position: 'relative',
    },
};


export default Details;
